import React from "react";
import { Route, Routes } from "react-router-dom";
import NotFound from "pages/common/notFound";
import SolutionMain from "./solutionMain";
import Allplace from "./allplace";
import DeviceOne from "./deviceOne";
import CmsManager from "./cmsManager";
import PrivateConnectManager from "./privateConnectManager";
import BeGate from "./beGate";
/**
 * 파일명: Solution.js
 * 작성자: 강연승
 * 작성일자: 25.02.06
 * 설명: 스마트 솔루션 라우터
 */
function Solution() {
  return (
    <Routes>
      {/* <Route path="" element={<SolutionMain />} /> */}
      <Route path="allplace" element={<Allplace />} />
      <Route path="begate" element={<BeGate />} />
      <Route path="cmsManager" element={<CmsManager />} />
      <Route path="privateConnectManager" element={<PrivateConnectManager />} />
      <Route path="deviceOne" element={<DeviceOne />} />
      <Route path="mediLink" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Solution;
